import { motion } from 'framer-motion';
import { useRef } from 'react';
import { useInView } from 'framer-motion';
import CourseImg1 from "../../assets/course-image-1.jpg";
import CourseImg2 from "../../assets/course-image-2.jpg";
import CourseImg3 from "../../assets/course-image-3.jpg";
import CourseImg4 from "../../assets/course-image-4.jpg";
import CourseImg5 from "../../assets/course-image-5.jpg";
import CourseImg6 from "../../assets/course-image-6.jpg";

const CourseSection = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: false });

  const courses = [
    { title: "SCIENCE STREAM", description: "Our Science Stream...", imageUrl: CourseImg1 },
    { title: "COMMERCE STREAM", description: "We offer comprehensive...", imageUrl: CourseImg2 },
    { title: "MATHEMATICS ENHANCEMENT PROGRAM", description: "Our Mathematics Enhancement...", imageUrl: CourseImg3 },
    { title: "PERSONALIZED SCIENCE COACHING", description: "Personalized Science Coaching...", imageUrl: CourseImg4 },
    { title: "PERSONALIZED COMMERCE COACHING", description: "We provide personalized...", imageUrl: CourseImg5 },
    { title: "FOUNDATION COURSE FOR SCIENCE AND COMMERCE", description: "Our Foundation Course...", imageUrl: CourseImg6 },
  ];
  
  const cardVariants = {
    hidden: (i) => ({
      opacity: 0,
      x: -500, // Reduced distance for smoother transition
    }),
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: {
        duration: 1, // Slightly shorter duration for responsiveness
        delay: i * 0.5, // Reduced stagger delay for smoother flow
        ease: "easeInOut", // Smooth easing effect
      },
    }),
    exit: (i) => ({
      opacity: 0,
      x: -50,
      transition: {
        duration: 0.8, // Shorter exit duration for better flow
        delay: i * 0.15,
        ease: "easeInOut", // Smooth exit easing
      },
    }),
  };

  return (
    <section ref={ref} className="padding w-full py-12" id="courses">
      <div className="text-center mb-8">
        <h2 className="text-4xl font-bold mb-6 text-blue-600">Our Courses</h2>
        <motion.div
          initial="hidden"
          animate={inView ? 'visible' : 'exit'}
          variants={{
            visible: {
              transition: {
                staggerChildren: 0.15, // Smoother stagger timing
              },
            },
            exit: {
              transition: {
                staggerChildren: 0.15,
              },
            },
          }}
          className="grid max-md:grid-cols-1 max-lg:grid-cols-2 grid-cols-3 gap-8"
        >
          {courses.map((course, index) => (
            <motion.div
              key={index}
              custom={index}
              initial="hidden"
              animate={inView ? 'visible' : 'exit'}
              variants={cardVariants}
              className="bg-white p-6 rounded-lg shadow-md"
            >
              <img src={course.imageUrl} alt="Course-img" className="w-full h-48 object-cover" />
              <h3 className="text-xl font-bold my-4">{course.title}</h3>
              <p>{course.description}</p>
              <button className="mt-4 bg-blue-500 text-white px-6 py-2 rounded-md">
                Learn More
              </button>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default CourseSection;
